// ISP-9999 (white-bar-across-bottom, headed repro C:/iYuga/qa-notes/vy/gray-
// gap-white-bar-repro-0906) — pure route match, extracted so it's unit
// testable without mounting <App/>.
//
// The builder (/builder/:id) and ViewWheel (/wheel/:wheelId) shells already
// subtract the live cookie-consent banner height from their own fixed 92vh
// layout via `calc(92vh - var(--iyuga-consent-reserve, 0px))` (SegmentBuilder/
// style.js, ViewWheel/styles.js). App.css's G-168 rule ALSO subtracts it, as
// `padding-bottom`, on the shared #main-content wrapper every route renders
// into — on these two routes that double-subtracts the reserve, so #root/
// .App/#main-content overflow the viewport by the banner's height (MEASURED:
// 1045px in a 945px viewport, banner up). This match decides which routes
// opt out of the global padding (see #main-content[data-fixed-viewport] in
// App.css). Deliberately excludes /wheel/segment/:id (renders <Segment/>, an
// ordinary scrolling page, not a fixed-viewport shell).
const FIXED_VIEWPORT_ROUTE_RE = /^\/(builder(\/|$)|wheel\/[^/]+\/?$)/;

export function isFixedViewportRoute(pathname) {
  return FIXED_VIEWPORT_ROUTE_RE.test(pathname);
}
